module.exports = __webpack_public_path__ + "static/media/asb_sur_typ_1.8012c737.png";